import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';

// SVG Traffic Light Icon Component
const TrafficLightSVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Background rectangle */}
    <rect
      x="10"
      y="2"
      width="12"
      height="28"
      rx="2"
      ry="2"
      fill="#FDB64E"
      stroke="#1A4C3A"
      strokeWidth="2"
    />

    {/* Pole */}
    <rect
      x="14"
      y="28"
      width="4"
      height="4"
      fill="#666666"
    />

    {/* Red light */}
    <circle
      cx="16"
      cy="8"
      r="3"
      fill="#EC1D23"
    />

    {/* Yellow light */}
    <circle
      cx="16"
      cy="16"
      r="3"
      fill="#F6ED60"
    />

    {/* Green light */}
    <circle
      cx="16"
      cy="24"
      r="3"
      fill="#8FC975"
    />
  </svg>
);

// Convert the React component to an HTML string
const trafficLightIconHtml = ReactDOMServer.renderToStaticMarkup(<TrafficLightSVG />);

// Create a data URL from the SVG
const trafficLightIconUrl = `data:image/svg+xml;base64,${btoa(trafficLightIconHtml)}`;

// Create the Leaflet icon
export const trafficLightIcon = L.icon({
  iconUrl: trafficLightIconUrl,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -28],
  shadowUrl: null
});

export default trafficLightIcon;